<div class="flex items-center justify-center h-full">
  <form
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
    class="bg-white px-4 py-8 sm:p-8 shadow-md rounded-lg w-full max-w-[420px]"
  >
    <div class="logo-bar">
      <img src="assets/maxbrain-logo.svg" alt="MaxBrain" />
    </div>

    <h2
      class="font-bold text-[28px] leading-8 tracking-normal text-center mb-6 text-[var(--color-darkgraytextcolor)]"
    >
      Log In
    </h2>

    <!-- Email Field -->
    <div class="mb-6">
      <div class="mb-2">
        <label
          for="email"
          class="font-normal text-sm leading-5 tracking-normal text-[var(--color-darkgraytextcolor)]"
          >Email
        </label>
      </div>
      <input
        id="email"
        type="email"
        formControlName="email"
        class="w-full p-2 border rounded h-[52px] focus:ring-0 focus:outline-none"
        [ngClass]="{
          'border-[#E0E0E0]':
            loginForm.get('email')?.valid || loginForm.get('email')?.untouched,
          'border-red-500':
            loginForm.get('email')?.invalid && loginForm.get('email')?.touched
        }"
      />
      <div
        class="text-red-500 text-sm mt-1"
        *ngIf="
          loginForm.get('email')?.invalid && loginForm.get('email')?.touched
        "
      >
        <small *ngIf="loginForm.get('email')?.errors?.['required']"
          >Email is required.</small
        >
        <small *ngIf="loginForm.get('email')?.errors?.['email']"
          >Invalid email format.</small
        >
      </div>
    </div>

    <!-- Password Field -->
    <div class="relative">
      <div class="mb-2">
        <label
          for="password"
          class="font-normal text-sm leading-5 tracking-normal text-[var(--color-darkgraytextcolor)]"
          >Password
        </label>
      </div>
      <div class="relative">
        <input
          id="password"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          class="w-full p-2 border rounded h-[52px] focus:ring-0 focus:outline-none pr-10"
          [ngClass]="{
            'border-[#E0E0E0]':
              loginForm.get('password')?.valid ||
              loginForm.get('password')?.untouched,
            'border-red-500':
              loginForm.get('password')?.invalid &&
              loginForm.get('password')?.touched
          }"
        />

        <!-- Toggle Password Visibility Button -->
        <button
          type="button"
          (click)="togglePassword()"
          class="absolute cursor-pointer inset-y-0 right-3 flex items-center justify-center text-gray-500"
        >
          <ng-icon
            *ngIf="showPassword"
            name="heroEyeSolid"
            size="20px"
            aria-hidden="true"
          ></ng-icon>
          <ng-icon
            *ngIf="!showPassword"
            name="heroEyeSlashSolid"
            size="20px"
            aria-hidden="true"
          ></ng-icon>
        </button>
      </div>

      <div
        class="text-red-500 text-sm mt-1"
        *ngIf="
          loginForm.get('password')?.invalid &&
          loginForm.get('password')?.touched
        "
      >
        <small *ngIf="loginForm.get('password')?.errors?.['required']"
          >Password is required.</small
        >
        <small *ngIf="loginForm.get('password')?.errors?.['minlength']"
          >Must be at least 6 characters.</small
        >
      </div>
    </div>

    <button
      type="submit"
      [disabled]="loginForm.invalid"
      class="w-full bg-[var(--color-primary-600)] cursor-pointer disabled:cursor-not-allowed text-white font-medium py-2 rounded mt-6 disabled:opacity-25 h-[48px]"
    >
      Login
    </button>

    <div class="text-center mt-4">
      <a
        class="text-sm leading-5 text-[var(--color-primary-800)]"
        routerLink="/reset-password"
      >
        New here or need to reset your password?
      </a>
    </div>
  </form>
</div>
